import posthog from "posthog-js";
import { useEffect, useRef } from "react";

import { AnalyticsQueryProvider } from "@/components/RequestsAnalytics/analytics-query-context";
import { TimezoneProvider } from "@/context/timezone-context";
import { REQUESTS_TAB_INDEX } from "@/components/RequestsAnalytics/constants";
import { RequestsAnalyticsPageHeader } from "@/components/RequestsAnalytics/RequestsAnalyticsPageHeader";
import RequestsAnalyticsLiveTail from "@/components/RequestsAnalytics/RequestsAnalyticsLiveTail";
import RequestsAnalyticsSearchbar from "@/components/RequestsAnalytics/RequestsAnalyticsSearchbar";
import RequestsAnalyticsTabs from "@/components/RequestsAnalytics/RequestsAnalyticsTabs";
import { RequestsAnalyticsTracking } from "@/components/RequestsAnalytics/RequestsAnalyticsTracking";
import { RequestLogsTableRefreshProvider } from "@/components/RequestsAnalytics/request-logs-table-refresh-context";
import { PageWrapper } from "@/components/UnifiedRegistry/BreadcrumbsPageWrapper";

const Requests = () => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current) {
      posthog.capture("Request Logs Page Viewed", {
        name: "Request Logs",
        href: window.location.href,
      });
      hasTracked.current = true;
    }
  }, []);

  return (
    <TimezoneProvider>
      <AnalyticsQueryProvider>
        <RequestLogsTableRefreshProvider>
          <PageWrapper className="flex h-full min-h-0 flex-col overflow-hidden px-3 pb-3 pt-4 sm:px-6 sm:pb-4 sm:pt-8">
            <RequestsAnalyticsTracking selectedTabIndex={REQUESTS_TAB_INDEX} />
            <RequestsAnalyticsPageHeader selectedTabIndex={REQUESTS_TAB_INDEX} />
            <RequestsAnalyticsLiveTail />
            <RequestsAnalyticsSearchbar />
            <RequestsAnalyticsTabs selectedTabIndex={REQUESTS_TAB_INDEX} />
          </PageWrapper>
        </RequestLogsTableRefreshProvider>
      </AnalyticsQueryProvider>
    </TimezoneProvider>
  );
};

export default Requests;
